export const normalizeAccountingSourceType = (sourceType) => {
  const normalized = String(sourceType ?? "").trim().toLowerCase();
  if (!normalized) return "";
  return normalized;
};

export const normalizeAccountingSourceId = (sourceId) => {
  const normalized = String(sourceId ?? "").trim();
  if (!normalized) return "";
  return normalized;
};

export const buildSourceExternalKey = (sourceType, sourceId) => {
  const normalizedSourceType = normalizeAccountingSourceType(sourceType);
  const normalizedSourceId = normalizeAccountingSourceId(sourceId);
  return normalizedSourceType && normalizedSourceId
    ? `${normalizedSourceType}:${normalizedSourceId}`
    : "";
};

export const parseSourceExternalKey = (sourceExternalKey) => {
  const raw = String(sourceExternalKey ?? "").trim();
  const separatorIndex = raw.indexOf(":");
  if (separatorIndex <= 0 || separatorIndex === raw.length - 1) {
    return { sourceType: "", sourceId: "", sourceExternalKey: "" };
  }
  const sourceType = normalizeAccountingSourceType(raw.slice(0, separatorIndex));
  const sourceId = normalizeAccountingSourceId(raw.slice(separatorIndex + 1));
  return {
    sourceType,
    sourceId,
    sourceExternalKey: sourceType && sourceId ? `${sourceType}:${sourceId}` : "",
  };
};
